export { pipePluralPostProcessor } from './pipe-plural-post-processor'
